import Axios from "axios"

export default {
    data: function () {
        return {
            mi_userUID: null
        }
    },
    methods: {
        mi_writeLog: function (path, message) {
            try{
                if (this.mi_userUID == null || this.mi_userUID == "") {
                    this.mi_userUID = this.$store.getters["loggedInUserUID"]
                }
                
                const userUID = this.mi_userUID == null || this.mi_userUID == "" ? "unknown" : this.mi_userUID
                const url = 'https://service.tomson.xyz/myfield_services/logger'
                Axios.get(url, {params: {userUID: userUID, message:"("+path+")"+message}}).then(function(res){
                    console.log(res)
                }).catch (function(error){
                    console.log(path, message, error)
                })
            } catch (error) {
                console.log(path, message, error)
            }
        }
        // mi_writeOperationLog: function (componentID, method, data) {
        //     console.log("mi_writeOperationLog", componentID, method, data)
        //     try{
        //         var db = this.$store.getters["localDB"]
        //         db.operationLog.put({
        //             dateTime: this.df_currentDateTime(),
        //             componentID: componentID,
        //             method: method,
        //             data: JSON.stringify(data)
        //         })
        //     } catch (error) {
        //         console.log(error)
        //     }
        // }
    }
}
